import { EOrder, EOrderBy, ICardQuery } from "@types";

export const getListParamsDefault: ICardQuery = {
  size: 1000,
  order: EOrder.DESC,
  orderBy: EOrderBy.CREATED_TIME,
};